import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "ghost" | "outline";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
}

const variants: Record<Variant, string> = {
  primary:
    "rounded-full bg-primary text-white hover:opacity-90 dark:bg-primary-dark disabled:opacity-50",
  ghost:
    "rounded-full bg-transparent text-ink dark:text-dark-ink hover:bg-black/5 dark:hover:bg-white/10",
  outline:
    "rounded-full border border-border bg-soft text-ink hover:bg-black/5 dark:border-dark-border dark:bg-dark-surface-elevated dark:text-dark-ink dark:hover:bg-white/5",
};

export function Button({
  variant = "primary",
  fullWidth,
  className = "",
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={[
        "inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold transition",
        variants[variant],
        fullWidth ? "w-full" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </button>
  );
}
